import { graphql } from '@apollo/client/react/hoc';

import { userProfileQuery } from '#src/lib/user';

const config = {
  props: ({ data }) => ({
    user: data.me,
  }),
};

export const withProfile = (customConfig) =>
  graphql(userProfileQuery, { ...config, ...customConfig });
